<nb-card>
  <nb-card-header>{{ title | translate }}</nb-card-header>
  <nb-card-body>
    <form [formGroup]="form">
      <div class="form-group">
        <label class="label">{{ 'tracking.startdate' | translate }}</label>
        <input nbInput
               fullWidth
               [nbDatepicker]="startPicker"
               formControlName="start"
               [max]="today">
        <nb-datepicker #startPicker [max]="today"></nb-datepicker>
      </div>
      <div class="form-group">
        <label class="label">{{ 'tracking.enddate' | translate }}</label>
        <input nbInput
               fullWidth
               [nbDatepicker]="endPicker"
               formControlName="end"
               [max]="today">
        <nb-datepicker #endPicker [max]="today"></nb-datepicker>
        @if (form.errors?.range) {
          <p class="caption status-danger">{{ 'tracking.trips.maxyear' | translate }}</p>
        }
      </div>
      <div class="form-group">
        <label class="label">{{ 'tracking.format' | translate }}</label>
        <nb-radio-group formControlName="format">
          @for (format of formats; track format) {
            <nb-radio [value]="format">{{ labels[format] }}</nb-radio>
          }
        </nb-radio-group>
      </div>
    </form>
  </nb-card-body>
  <nb-card-footer>
    <button nbButton ghost (click)="cancel()">{{ 'cancel' | translate }}</button>
    <button nbButton status="primary" (click)="submit()" [bstErroring]="form">
      <nb-icon icon="download-outline"></nb-icon>
      {{ 'export' | translate }}
    </button>
  </nb-card-footer>
</nb-card>